<template>
  <div class="legendBackdrop" @click.self="close">
    <section
      class="colorsContainer"
      role="dialog"
      aria-modal="true"
      aria-labelledby="colors-legend-title"
    >
      <div class="legendHeader">
        <h2 id="colors-legend-title">Legenda kolorów</h2>
        <button
          ref="closeButton"
          type="button"
          class="closeButton"
          aria-label="Zamknij legendę kolorów"
          @click="close"
        >
          ×
        </button>
      </div>
      <color-item
        v-for="color in colors"
        :img="color.image"
        :key="color.number"
        :item-number="color.number"
        :bg-color="color.backgroundColor"
        :text-color="color.textColor"
        :item-description="color.description"
      ></color-item>
    </section>
  </div>
</template>

<script>
import { COLORS } from '../data/colors';
import ColorItem from './ColorItem.vue';

export default {
  components: {
    ColorItem,
  },
  emits: ['close'],
  data() {
    return {
      colors: COLORS,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
    this.$nextTick(() => this.$refs.closeButton.focus());
  },
  unmounted() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
};
</script>

<style scoped>
.legendBackdrop {
  position: fixed;
  z-index: 101;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 16px;
  background: rgb(0 0 0 / 70%);
}

.colorsContainer {
  width: min(100%, 540px);
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  border-radius: 20px;
  background-color: rgb(10, 10, 10);
  box-shadow: 0 20px 60px rgb(0 0 0 / 60%);
}

.legendHeader {
  display: flex;
  position: sticky;
  top: 0;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  color: #fff;
  background-color: rgb(10, 10, 10);
}

.legendHeader h2 {
  margin: 0;
  font-size: 1.1rem;
}

.closeButton {
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 50%;
  color: #fff;
  background: transparent;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
}

.closeButton:hover,
.closeButton:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
  background: rgb(255 255 255 / 15%);
}
</style>
